import { useMemo } from "react";
import { useAppSelector } from "Store/hooks";
import { selectTenants } from "../redux/selectors";
import { columns } from "./columns/columns";
import { Table } from "antd";

interface TenantsTableProps {
  searchText?: string;
}

const TenantsTable = ({ searchText = "" }: TenantsTableProps) => {
  const tenantsList = useAppSelector(selectTenants);

  const filteredList = useMemo(() => {
    if (!searchText.trim()) return tenantsList;
    const term = searchText.toLowerCase();
    return tenantsList?.filter((tenant: any) =>
      [tenant.name, tenant.description, tenant.organizationName, tenant.status]
        .filter(Boolean)
        .some((field: string) => field.toLowerCase().includes(term))
    );
  }, [tenantsList, searchText]);

  return (
    <Table
      style={{ padding: "0px" }}
      columns={columns}
      dataSource={filteredList}
    />
  );
};
export default TenantsTable;
